// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/backgrounds/vidi-accounts-bkg-small.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/backgrounds/vidi-accounts-bkg-65.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/backgrounds/vidi-accounts-bkg-100.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-poppins:
    "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

* {
  box-sizing: border-box;
}

body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: var(--font-poppins);
  margin: 0;
}

.slideshow-page-root {
  height: max-content;
  margin-inline: auto;
  min-height: 100vh;
}

/* Reminder that the order of the animation props matters */
.splash {
  align-items: center;
  background-color: white;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99999;
}

.splash svg {
  width: 50%;
}

/* PhotoAlbum styles */
.PhotoAlbum-header {
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 60px;
  padding: 24px 16px 16px;
}

.PhotoAlbum-title {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* number of lines to show */
  color: rgb(71, 71, 71);
  display: -webkit-box;
  font-family: var(--font-poppins);
  font-size: 1.5rem;
  line-clamp: 3;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
}

@media (max-width: 1200px) {
  .PhotoAlbum-description {
    min-width: 20%;
  }
}

@media (max-width: 720px) {
  .PhotoAlbum-header {
    flex-wrap: wrap;
    gap: 30px;
  }

  .PhotoAlbum-title {
    font-size: 1.3rem;
  }

  .PhotoAlbum-description {
    min-width: 30%;
  }
}

@media (max-width: 420px) {
  .PhotoAlbum-header {
    gap: 10px;
  }

  .PhotoAlbum-title {
    font-size: 1.2rem;
  }
}

.PhotoAlbum-link {
  color: rgb(71, 71, 71);
  font-family: var(--font-poppins);
  font-size: 1.5rem;
}

.PhotoAlbum-link:hover {
  color: black;
}

.PhotoAlbum-description {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* number of lines to show */
  color: rgb(87, 87, 87);
  display: -webkit-box;
  font-family: var(--font-poppins);
  font-size: 1.1rem;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
}

@media (max-width: 1200px) {
  .PhotoAlbum-description {
    min-width: 20%;
  }
}

@media (max-width: 720px) {
  .PhotoAlbum-description {
    min-width: 30%;
  }
}

@media (max-width: 420px) {
  .PhotoAlbum-description {
    font-size: 1rem;
  }
}

.PhotoAlbumUnavailable-root {
  align-items: center;
  background-attachment: fixed;
  background-color: #0b1220;
  background-image:
    linear-gradient(rgba(11, 18, 32, 0.45), rgba(11, 18, 32, 0.45)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: repeat;
  background-size: cover;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 99999;
}

.PhotoAlbumUnavailable-content {
  align-items: center;
  background-color: white;
  color: black;
  display: flex;
  flex-direction: column;
  max-width: 600px;
  padding: 48px 32px;
  width: 100%;
}

.PhotoAlbumUnavailable-title {
  font-size: 2rem;
  font-family: var(--font-poppins);
  font-weight: 600;
  line-height: 1.2;
  margin: 32px 0 0;
}

.PhotoAlbumUnavailable-logo {
  width: 72px;
}

.PhotoAlbumUnavailable-logo svg {
  height: auto;
  width: 100%;
}

.PhotoAlbumUnavailable-logo path {
  fill: #4b3278;
}

.PhotoAlbumUnavailable-logo circle {
  fill: #ff644f;
}

.PhotoAlbumUnavailable-message {
  font-size: 1.125rem;
  line-height: 1.5;
  margin: 16px 0 0;
}

@media (min-width: 600px) {
  .PhotoAlbumUnavailable-root {
    background-image:
      linear-gradient(rgba(11, 18, 32, 0.45), rgba(11, 18, 32, 0.45)),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}

@media (min-width: 900px) {
  .PhotoAlbumUnavailable-root {
    background-image:
      linear-gradient(rgba(11, 18, 32, 0.45), rgba(11, 18, 32, 0.45)),
      url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
}

@media (max-width: 420px) {
  .PhotoAlbumUnavailable-content {
    padding: 32px 24px;
  }

  .PhotoAlbumUnavailable-title {
    font-size: 1.875rem;
  }

  .PhotoAlbumUnavailable-message {
    font-size: 1rem;
  }
}

/* Lightbox styles */
.Lightbox-logo {
  bottom: 0;
  height: 48px;
  left: 0;
  position: absolute;
  width: 48px;
  z-index: 100;
}

.Lightbox-logo svg,
.Lightbox-description-toggle svg {
  fill: currentColor;
}

.Lightbox-description-toggle {
  bottom: 0;
  height: 48px;
  padding: 6px;
  position: absolute;
  right: 0;
  width: 48px;
  z-index: 100;
}

.Lightbox-description-toggle .yarl__icon {
  height: 24px;
  width: 24px;
}

/* Yet another react lightbox styles: */
.yarl__slide_title {
  --yarl__slide_title_font_size: 125%;
  --yarl__slide_title_font_weight: 600;
  font-family: var(--font-poppins);
}

@media (max-width: 1000px) {
  .yarl__slide_title {
    --yarl__slide_title_font_size: 115%;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4; /* number of lines to show */
    display: -webkit-box;
    line-clamp: 4;
    white-space: wrap !important;
    word-wrap: break-word;
  }
}

@media (max-width: 720px) {
  .yarl__slide_title {
    --yarl__slide_title_font_size: 105%;
    --yarl__slide_title_font_weight: 500;
  }
}

@media (max-width: 420px) {
  .yarl__slide_title {
    --yarl__slide_title_font_size: 95%;
    --yarl__slide_title_font_weight: 400;
  }

  .yarl__toolbar > .yarl__button {
    padding: 4px;
  }
}

.yarl__slide_description {
  font-family: var(--font-poppins);
  margin-left: 40px;
  margin-right: 20px;
}

.yarl__thumbnails_container {
  border-top: rgba(255, 255, 255, 0.3) solid 1px;
  padding: 16px;
}

.autohide-controls .yarl__toolbar,
.autohide-controls .yarl__navigation_next,
.autohide-controls .yarl__navigation_prev {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.show-contols .yarl__toolbar,
.show-contols .yarl__navigation_next,
.show-contols .yarl__navigation_prev {
  opacity: 1;
  transition: opacity 1s ease-in-out;
}

/* Animation styles */
.fade-out {
  animation: fade-out 3s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}

.loader {
  align-items: center;
  animation: fade-out-background 2s linear;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99999;
}

.spinner {
  animation: rotation 1s linear infinite;
  border-radius: 50%;
  border: 4px solid #fff;
  box-sizing: border-box;
  display: inline-block;
  height: 48px;
  position: relative;
  width: 48px;
}

.spinner::after {
  background: #15ff00;
  box-sizing: border-box;
  content: "";
  height: 24px;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  width: 3px;
}

/* Overrides: */
.dark-bkg {
  background-color: black;
}

.transparent-bkg {
  /* Yet another react lightbox styles: */
  --yarl__container_background_color: transparent;
  --yarl__thumbnails_container_background_color: transparent;
  --yarl__thumbnails_thumbnail_background: transparent;
  --yarl__color_backdrop: transparent;
  background-color: transparent;
}

.light-text {
  color: white;
}

/* Animations: */
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fade-out-background {
  from {
    background-color: rgba(255, 255, 255, 0.3);
  }
  to {
    background-color: transparent;
  }
}
`, "",{"version":3,"sources":["webpack://./build/public/globals.css"],"names":[],"mappings":"AAAA;EACE;;wEAEsE;AACxE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB,EAAE,4BAA4B;EACnD,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB,EAAE,4BAA4B;EACnD,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB;;2CAE0D;EAC1D,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE;;6CAEuD;EACzD;AACF;;AAEA;EACE;IACE;;6CAEwD;EAC1D;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE;IACE,mCAAmC;IACnC,4BAA4B;IAC5B,qBAAqB,EAAE,4BAA4B;IACnD,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,oCAAoC;EACtC;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,aAAa;AACf;;AAEA;;;EAGE,UAAU;EACV,kCAAkC;AACpC;;AAEA;;;EAGE,UAAU;EACV,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,0DAA0D;EAC1D,oDAAoD;EACpD,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[":root {\n  --font-poppins:\n    \"Poppins\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  font-family: var(--font-poppins);\n  margin: 0;\n}\n\n.slideshow-page-root {\n  height: max-content;\n  margin-inline: auto;\n  min-height: 100vh;\n}\n\n/* Reminder that the order of the animation props matters */\n.splash {\n  align-items: center;\n  background-color: white;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 99999;\n}\n\n.splash svg {\n  width: 50%;\n}\n\n/* PhotoAlbum styles */\n.PhotoAlbum-header {\n  align-items: center;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  gap: 60px;\n  padding: 24px 16px 16px;\n}\n\n.PhotoAlbum-title {\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3; /* number of lines to show */\n  color: rgb(71, 71, 71);\n  display: -webkit-box;\n  font-family: var(--font-poppins);\n  font-size: 1.5rem;\n  line-clamp: 3;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-wrap: break-word;\n}\n\n@media (max-width: 1200px) {\n  .PhotoAlbum-description {\n    min-width: 20%;\n  }\n}\n\n@media (max-width: 720px) {\n  .PhotoAlbum-header {\n    flex-wrap: wrap;\n    gap: 30px;\n  }\n\n  .PhotoAlbum-title {\n    font-size: 1.3rem;\n  }\n\n  .PhotoAlbum-description {\n    min-width: 30%;\n  }\n}\n\n@media (max-width: 420px) {\n  .PhotoAlbum-header {\n    gap: 10px;\n  }\n\n  .PhotoAlbum-title {\n    font-size: 1.2rem;\n  }\n}\n\n.PhotoAlbum-link {\n  color: rgb(71, 71, 71);\n  font-family: var(--font-poppins);\n  font-size: 1.5rem;\n}\n\n.PhotoAlbum-link:hover {\n  color: black;\n}\n\n.PhotoAlbum-description {\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3; /* number of lines to show */\n  color: rgb(87, 87, 87);\n  display: -webkit-box;\n  font-family: var(--font-poppins);\n  font-size: 1.1rem;\n  line-clamp: 3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-wrap: break-word;\n}\n\n@media (max-width: 1200px) {\n  .PhotoAlbum-description {\n    min-width: 20%;\n  }\n}\n\n@media (max-width: 720px) {\n  .PhotoAlbum-description {\n    min-width: 30%;\n  }\n}\n\n@media (max-width: 420px) {\n  .PhotoAlbum-description {\n    font-size: 1rem;\n  }\n}\n\n.PhotoAlbumUnavailable-root {\n  align-items: center;\n  background-attachment: fixed;\n  background-color: #0b1220;\n  background-image:\n    linear-gradient(rgba(11, 18, 32, 0.45), rgba(11, 18, 32, 0.45)),\n    url(\"./assets/backgrounds/vidi-accounts-bkg-small.webp\");\n  background-position: center;\n  background-repeat: repeat;\n  background-size: cover;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  left: 0;\n  padding: 24px;\n  position: fixed;\n  right: 0;\n  text-align: center;\n  top: 0;\n  z-index: 99999;\n}\n\n.PhotoAlbumUnavailable-content {\n  align-items: center;\n  background-color: white;\n  color: black;\n  display: flex;\n  flex-direction: column;\n  max-width: 600px;\n  padding: 48px 32px;\n  width: 100%;\n}\n\n.PhotoAlbumUnavailable-title {\n  font-size: 2rem;\n  font-family: var(--font-poppins);\n  font-weight: 600;\n  line-height: 1.2;\n  margin: 32px 0 0;\n}\n\n.PhotoAlbumUnavailable-logo {\n  width: 72px;\n}\n\n.PhotoAlbumUnavailable-logo svg {\n  height: auto;\n  width: 100%;\n}\n\n.PhotoAlbumUnavailable-logo path {\n  fill: #4b3278;\n}\n\n.PhotoAlbumUnavailable-logo circle {\n  fill: #ff644f;\n}\n\n.PhotoAlbumUnavailable-message {\n  font-size: 1.125rem;\n  line-height: 1.5;\n  margin: 16px 0 0;\n}\n\n@media (min-width: 600px) {\n  .PhotoAlbumUnavailable-root {\n    background-image:\n      linear-gradient(rgba(11, 18, 32, 0.45), rgba(11, 18, 32, 0.45)),\n      url(\"./assets/backgrounds/vidi-accounts-bkg-65.webp\");\n  }\n}\n\n@media (min-width: 900px) {\n  .PhotoAlbumUnavailable-root {\n    background-image:\n      linear-gradient(rgba(11, 18, 32, 0.45), rgba(11, 18, 32, 0.45)),\n      url(\"./assets/backgrounds/vidi-accounts-bkg-100.webp\");\n  }\n}\n\n@media (max-width: 420px) {\n  .PhotoAlbumUnavailable-content {\n    padding: 32px 24px;\n  }\n\n  .PhotoAlbumUnavailable-title {\n    font-size: 1.875rem;\n  }\n\n  .PhotoAlbumUnavailable-message {\n    font-size: 1rem;\n  }\n}\n\n/* Lightbox styles */\n.Lightbox-logo {\n  bottom: 0;\n  height: 48px;\n  left: 0;\n  position: absolute;\n  width: 48px;\n  z-index: 100;\n}\n\n.Lightbox-logo svg,\n.Lightbox-description-toggle svg {\n  fill: currentColor;\n}\n\n.Lightbox-description-toggle {\n  bottom: 0;\n  height: 48px;\n  padding: 6px;\n  position: absolute;\n  right: 0;\n  width: 48px;\n  z-index: 100;\n}\n\n.Lightbox-description-toggle .yarl__icon {\n  height: 24px;\n  width: 24px;\n}\n\n/* Yet another react lightbox styles: */\n.yarl__slide_title {\n  --yarl__slide_title_font_size: 125%;\n  --yarl__slide_title_font_weight: 600;\n  font-family: var(--font-poppins);\n}\n\n@media (max-width: 1000px) {\n  .yarl__slide_title {\n    --yarl__slide_title_font_size: 115%;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 4; /* number of lines to show */\n    display: -webkit-box;\n    line-clamp: 4;\n    white-space: wrap !important;\n    word-wrap: break-word;\n  }\n}\n\n@media (max-width: 720px) {\n  .yarl__slide_title {\n    --yarl__slide_title_font_size: 105%;\n    --yarl__slide_title_font_weight: 500;\n  }\n}\n\n@media (max-width: 420px) {\n  .yarl__slide_title {\n    --yarl__slide_title_font_size: 95%;\n    --yarl__slide_title_font_weight: 400;\n  }\n\n  .yarl__toolbar > .yarl__button {\n    padding: 4px;\n  }\n}\n\n.yarl__slide_description {\n  font-family: var(--font-poppins);\n  margin-left: 40px;\n  margin-right: 20px;\n}\n\n.yarl__thumbnails_container {\n  border-top: rgba(255, 255, 255, 0.3) solid 1px;\n  padding: 16px;\n}\n\n.autohide-controls .yarl__toolbar,\n.autohide-controls .yarl__navigation_next,\n.autohide-controls .yarl__navigation_prev {\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n}\n\n.show-contols .yarl__toolbar,\n.show-contols .yarl__navigation_next,\n.show-contols .yarl__navigation_prev {\n  opacity: 1;\n  transition: opacity 1s ease-in-out;\n}\n\n/* Animation styles */\n.fade-out {\n  animation: fade-out 3s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: 1;\n}\n\n.loader {\n  align-items: center;\n  animation: fade-out-background 2s linear;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 99999;\n}\n\n.spinner {\n  animation: rotation 1s linear infinite;\n  border-radius: 50%;\n  border: 4px solid #fff;\n  box-sizing: border-box;\n  display: inline-block;\n  height: 48px;\n  position: relative;\n  width: 48px;\n}\n\n.spinner::after {\n  background: #15ff00;\n  box-sizing: border-box;\n  content: \"\";\n  height: 24px;\n  left: 50%;\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n  width: 3px;\n}\n\n/* Overrides: */\n.dark-bkg {\n  background-color: black;\n}\n\n.transparent-bkg {\n  /* Yet another react lightbox styles: */\n  --yarl__container_background_color: transparent;\n  --yarl__thumbnails_container_background_color: transparent;\n  --yarl__thumbnails_thumbnail_background: transparent;\n  --yarl__color_backdrop: transparent;\n  background-color: transparent;\n}\n\n.light-text {\n  color: white;\n}\n\n/* Animations: */\n@keyframes fade-out {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fade-out-background {\n  from {\n    background-color: rgba(255, 255, 255, 0.3);\n  }\n  to {\n    background-color: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
